import { render } from "./TableStudents.vue?vue&type=template&id=0d03d9cc"
import script from "./TableStudents.vue?vue&type=script&lang=js"
export * from "./TableStudents.vue?vue&type=script&lang=js"

import "./TableStudents.vue?vue&type=style&index=0&id=0d03d9cc&lang=scss"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__